import Breakpoint from '../../../../../../core-lib/js/Breakpoint/Breakpoint';

export default class AdSlot {

	constructor(el) {
		this.el = el;
		this.ad = this.el.querySelector('.ad-slot__ad--generated');

		if (this.ad) {

			window.googletag = window.googletag || {};
			window.googletag.cmd = window.googletag.cmd || [];

			this.id = this.ad.id;
			this.slotCode = this.getSlotCode();
			this.platform = (window.innerWidth > 1024) ? 'web' : 'mweb';
			this.videoCompanion = this.ad.dataset.videoCompanion;
			this.size = this.getSize();
			
			this.defineSlot();

			this.hero = this.el.previousElementSibling;

			this.positionAdAfterHero = this.positionAdAfterHero.bind(this);
			this.onAdBreakpoint = this.onAdBreakpoint.bind(this);

			this.positionAdAfterHero();
			this.addBreakpoints();
		}
	}

	getSlotCode() {
		let slotCode = this.ad.dataset.slotCode;

		if (this.el.parentElement.classList.contains('dfp-pixel')) {
			slotCode = this.el.parentElement.dataset.slotCode;
			this.ad.dataset.slotCode = slotCode;
		}

		return slotCode;
	}

	getSize() {
		let size = [];

		if (this.videoCompanion == '1') {
			const ciu_szs = vb.ima3_ciu_szs.split(',');

			for (let ciu_sz of ciu_szs) {
				const sz = ciu_sz.split('x');

				for (let i in sz) {
					sz[i] = parseInt(sz[i]);
				}

				if (sz.length == 2) {
					size.push(sz);
				}
			}
		} else {
			size = [320, 50];
		}

		return size;
	}

	defineSlot() {
		let gSlot = null;

		if (window.googletag) {
			window.googletag.cmd.push(() => {
				gSlot = window.googletag.defineSlot(this.slotCode, this.size, this.id);

				if (vb.adSizeMapping[this.id]) {
					let sizeMapping = googletag.sizeMapping();

					for (const mapping of vb.adSizeMapping[this.id].sizes) {
						sizeMapping = sizeMapping.addSize(mapping.screen_size, mapping.ad_sizes);
					}

					sizeMapping = sizeMapping.build();

					gSlot.defineSizeMapping(sizeMapping);
				} else {
					console.warn(`Missing Google Ads size mapping (${this.id})`)
				}

				for (let targeting of vb.adTargeting[this.id]) {
					gSlot.setTargeting(targeting.name, [targeting.value]);
				}

				if (this.el.parentElement.classList.contains('swimlane__item--ad')) {
					gSlot.setTargeting('swimlane', this.el.parentElement.dataset.swimlane);
					gSlot.setTargeting('background', this.el.parentElement.dataset.background);
					gSlot.setTargeting('wwspt', this.el.parentElement.dataset.itemStyle);
				}

				gSlot.setTargeting('platform', this.platform + vb.environment);
				gSlot.setTargeting('postId', vb.currentId);
				gSlot.setCollapseEmptyDiv(true, true);

				if (this.videoCompanion == '1') {
					gSlot.addService(googletag.companionAds());
				}

				gSlot.addService(window.googletag.pubads());

				this.gSlot = gSlot

				vb.gSlots[this.id] = this.gSlot;
			});
		}
	}

	positionAdAfterHero() {
		if (this.hero && this.hero.classList.contains('hero--multi')) {
			if (window.innerWidth < 1024) {
				const heroSwimlane = this.hero.querySelector('.hero__tabs');
				if (heroSwimlane) {
					heroSwimlane.parentElement.insertBefore(this.el, heroSwimlane);
				}
			}
		}
	}

	addBreakpoints() {
		new Breakpoint('max', 1023, this.positionAdAfterHero);

		if (vb.adSizeMapping[this.id]) {
			for (const mapping of vb.adSizeMapping[this.id].sizes) {
				new Breakpoint('min', mapping.screen_size[0], this.onAdBreakpoint);
			}
		}
	}

	onAdBreakpoint() {
		if (window.googletag) {
			window.googletag.pubads().refresh([this.gSlot]);
		}
	}
}
